import { createFileRoute } from '@tanstack/react-router'
import { Provider } from 'react-redux'
import z from 'zod'
import { SearchPageProvider } from '~/modules/search-page'
import { store } from '~/stores/store'

import SearchContactLogs from './-components/SearchContactLogs'

const searchSchema = z.object({
  q: z.string(),
  qf: z
    .object({
      from: z.string().array().optional(),
    })
    .optional(),
})

export const Route = createFileRoute('/_authenticated/$alias/_app/search/')({
  component: RouteComponent,
  validateSearch: searchSchema,
})

function RouteComponent() {
  return (
    <Provider store={store}>
      <SearchPageProvider>
        <SearchContactLogs />
      </SearchPageProvider>
    </Provider>
  )
}
